import { INTERACTIVE } from 'global/constants';
import {
  StimulusLibrary,
  StimulusLibraryCreate,
} from '../shared/stimulus-library';
import InteractiveEditDrawer from './interactive-edit-drawer';
import { Props } from './interactive-settings.constants';
import { getStimulusLabel } from '../shared/logic/get-stimulus-label';

const InteractiveSettings = (props: Props) => {
  return props.properties.stimulusId ? (
    <InteractiveEditDrawer title={getStimulusLabel(INTERACTIVE)} {...props} />
  ) : (
    <StimulusLibrary
      stimulusType={INTERACTIVE}
      componentId={props.id}
      title={getStimulusLabel(INTERACTIVE)}
      canGoBack={false}
      headerActionButton={
        <StimulusLibraryCreate
          sectionId={props.sectionId}
          componentId={props.id}
          contentId={props.lessonId}
          type={INTERACTIVE}
        />
      }
      {...props}
    />
  );
};

export default InteractiveSettings;
